import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@e2n/ui';
import { StandorteDropdown } from '@/domain/navigation/features/navigation/components/StandorteDropdown/StandorteDropdown';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export function HomeItem() {
  const { currentStandort, updateToNext, updateToPrevious, standorte } =
    useStandortContext();

  return (
    <div className="flex items-center gap-1">
      {standorte.length > 1 && (
        <>
          <StandorteDropdown />
          <Button
            variant="ghost"
            className="hidden sm:flex size-8"
            onClick={updateToPrevious}>
            <FontAwesomeIcon icon={faChevronLeft} className="size-4" />
          </Button>
          <Button
            variant="ghost"
            className="hidden sm:flex size-8"
            onClick={updateToNext}>
            <FontAwesomeIcon icon={faChevronRight} className="size-4" />
          </Button>
        </>
      )}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to="/"
              className="text-sm font-semibold text-neutrals-800 p-2 transition-colors hover:bg-neutrals-200 rounded-md max-w-32 truncate">
              {`${currentStandort.storeNummer ? `${currentStandort.storeNummer} - ` : ''}${currentStandort.name}`}
            </Link>
          </TooltipTrigger>
          <TooltipContent className="max-w-64">
            {`${currentStandort.storeNummer ? `${currentStandort.storeNummer} - ` : ''}${currentStandort.name}`}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
